import { Component } from '@angular/core';

@Component({
	selector: 'app-sponsors',
	templateUrl: './sponsors.component.html',
	styleUrls: ['./sponsors.component.scss'],
})
export class SponsorsComponent {}
